import * as React from 'react';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import { ShareButton } from './ShareButton';
import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { RaffleItem } from './RaffleItem';
import { auth } from '../../firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import RafflesComponent from '../../components/Raffles/Raffles';
import { useRaffleContext } from '../../contexts/RaffleContext';
import { CloseOutlined } from '@mui/icons-material';
import FaviconSwitcher from './FaviconSwitcher';
import { IRaffle } from './models';


export interface ShareModalProps {
  open: boolean;
  onClose: (value: string) => void;
  id: string;
}

function ShareModalDialog(props: ShareModalProps) {
  const { onClose, open, id } = props;
  const [user] = useAuthState(auth)
  const { raffles } = useRaffleContext()
  const [raffle, setRaffle] = useState<IRaffle | null>(null);
  useEffect(() => {
    if (raffles?.length) {
      const found = raffles.find(x => x.id === id)
      setRaffle(found)
    }
  }, [raffles])

  const handleClose = () => {
    onClose(id);

    const url = new URL(window.location.href);
    url.searchParams.delete('id');
    window.history.replaceState({}, '', url.toString());
  };

  const handleListItemClick = (value: string) => {
    onClose(value);
  };

  if (!raffle) {
    return null
  }
  return (<>
    {/* {children || null} */}
    <FaviconSwitcher flag={open} fallbackHref={raffle.raffleImages[0]} />
    <Dialog onClose={handleClose} open={open} sx={{ width: '100vw' }} fullWidth>
      <div style={{
        justifyContent: 'end',
        display: 'flex',
        margin: 1,
        width: '100%'
      }}>
        <Button variant='text' onClick={handleClose}>
          <CloseOutlined fontSize='large' color="error" />
        </Button>
      </div>
      <RafflesComponent raffle={raffle} />

    </Dialog>
  </>
  );
}


export default function ShareModal() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [id, setId] = useState<any | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');
    if (id) {
      setId(id)
      setLoading(false);
      setOpen(true);
    }
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value: string) => {
    setOpen(false);
  };

  return (
    <div>
      {/* <Typography variant="subtitle1" component="div">
        Selected: {selectedValue}
      </Typography>
      <br />
      <Button variant="outlined" onClick={handleClickOpen}>
        Open simple dialog
      </Button> */}
      {loading ? (
        <Spinner />
      ) : id ? (
        <ShareModalDialog
          open={open}
          onClose={handleClose}
          id={id}
        />
      ) : (
        <Typography>No se pudo cargar el contenido.</Typography>
      )}


    </div>
  );
}


